module.exports = __webpack_public_path__ + "static/amazon-button-6a40d356f85ae05d2bec4e2a29f0a13e.png";